import { render, staticRenderFns } from "./cryoem_reservations_list.vue?vue&type=template&id=29b1c45c&scoped=true&"
import script from "./cryoem_reservations_list.vue?vue&type=script&lang=js&"
export * from "./cryoem_reservations_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b1c45c",
  null
  
)

export default component.exports